module.exports = __webpack_public_path__ + "img/Jump Casting36.ea6225de.jpg";